import { Reducer } from "redux";
import { MASTERFORMAT_WITH_UNIFORMAT_LOADED, MasterformatWithUniformatLoadedEvent } from "../../../events/loaded/masterformat_with_uniformat_loaded";
import { ApiMasterFormatWithUniformat } from "avvir";

export interface MasterFormatWithUniformatStore {
  masterformatWithUniformat: ApiMasterFormatWithUniformat[];
}

const noMasterformatWithUniformatProvided = {
  masterformatWithUniformat: [
    {
      masterformat: {
        version: 2016,
        code: "undefined",
        description: "Unknown Material",
        masterformatId: {
          version: 2016,
          code: "undefined",
        },
      },
      uniformat: "undefined",
    },
  ],
};

const reduceMasterFormatsWithUniformat: Reducer<
  MasterFormatWithUniformatStore,
  MasterformatWithUniformatLoadedEvent
> = (
  masterformatWithUniformat = noMasterformatWithUniformatProvided as MasterFormatWithUniformatStore,
  event,
) => {
  switch (event.type) {
    case MASTERFORMAT_WITH_UNIFORMAT_LOADED: {
      return event.payload.reduce(
        (masterformatWithUniformatSoFar, masterformatWithUniformat) => {
          return {
            ...masterformatWithUniformatSoFar,
            masterformatWithUniformat: [
              ...masterformatWithUniformatSoFar.masterformatWithUniformat,
              masterformatWithUniformat,
            ],
          };
        },
        { masterformatWithUniformat: [] } as MasterFormatWithUniformatStore,
      );
    }
    default: {
      return masterformatWithUniformat;
    }
  }
};

export default reduceMasterFormatsWithUniformat;